// extracted by mini-css-extract-plugin
module.exports = {"advicesContainer":"_1Y6Iyub8","searchBuilder":"_329jN69F"};